"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/AuthFrame/CodeInput.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);












// Six code boxes over one real input. The single input keeps one-time-code
// autofill, paste and backspace working as in any text field; the boxes only
// draw its value.
const CodeInput = _react.forwardRef(function CodeInput ({
  value,
  onChange,
  length = 6,
  autoFocus,
  isDisabled,
  hasError,
  describedBy,
  label = `${length}-digit code`,
}, ref) {
  const [isFocused, setIsFocused] = _react.useState.call(void 0, false)
  const digits = value.split('')
  const activeIndex = Math.min(value.length, length - 1)

  return (
    _react2.default.createElement('div', {
      className: _classBuilder2.default.call(void 0, 
        'auth-code',
        hasError && 'auth-code--error',
        isDisabled && 'auth-code--disabled',
      ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 34}}

      , _react2.default.createElement('input', {
        ref: ref,
        className: "auth-code--input",
        type: "text",
        name: "code",
        inputMode: "numeric",
        pattern: "[0-9]*",
        autoComplete: "one-time-code",
        autoFocus: autoFocus,
        disabled: isDisabled,
        maxLength: length,
        'aria-label': label,
        'aria-invalid': hasError || undefined,
        'aria-describedby': describedBy,
        value: value,
        onChange: e => onChange(e.target.value.replace(/\D/g, '').slice(0, length)),
        onFocus: () => setIsFocused(true),
        onBlur: () => setIsFocused(false), __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}}
      )
      , _react2.default.createElement('div', { className: "auth-code--boxes", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}
        ,  Array.from({ length }, (_, i) => (
          _react2.default.createElement('span', {
            key: i,
            className: _classBuilder2.default.call(void 0, 
              'auth-code--box',
              isFocused && i === activeIndex && value.length < length && 'auth-code--box--focus',
              isFocused && value.length === length && i === length - 1 && 'auth-code--box--focus',
            ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}

            ,  digits[i] || '' 
          )
        ))
      )
    )
  )
})

exports. default = CodeInput
